import { AnalyticsConfig } from '../analytics';

const googleAnalyticsConfig = {
  prod: 'G-0R4TZLY420',
  preprod: 'G-FJ6MJ3QKR2',
  dev: 'G-WM8FTS4SWJ',
} as AnalyticsConfig;

export default googleAnalyticsConfig;
